import { Link } from 'react-router-dom'
import type { SurveyListItem } from '../types/survey'
import '../styles/survey-list.css'

interface SurveyListProps {
  surveys: SurveyListItem[]
}

export function SurveyList({ surveys }: SurveyListProps) {
  if (surveys.length === 0) {
    return (
      <div className="survey-list-empty">
        <p>No surveys are currently available.</p>
      </div>
    )
  }

  return (
    <ul className="survey-list">
      {surveys.map((survey) => (
        <li key={survey.id} className="survey-list-item">
          <Link to={`/survey/${survey.id}`} className="survey-list-link">
            <div className="survey-list-content">
              <h2 className="survey-list-title">{survey.title}</h2>
              {survey.description && (
                <p className="survey-list-description">{survey.description}</p>
              )}
              <span className="survey-list-meta">
                {new Date(survey.createdAt).toLocaleDateString()}
              </span>
            </div>
            <span className="survey-list-arrow" aria-hidden="true">→</span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
